import { useEffect, useState, useRef } from 'react';
import { FormGroup, FormControlLabel, Checkbox, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'HkTaskName', label: 'Task', minWidth: 70 },
    { id: 'Abrv', label: 'Abbrivation', minWidth: 70 },
    { id: 'Remark', label: 'Remark', minWidth: 70 },
];

const HKTaskMaster = () => {
    const [formData, setFormData] = useState({
        HkTaskName: '',
        Abrv: '',
        Remark: '',
    });

    const [error, setError] = useState({
        HkTaskName: false,
        Abrv: false,
    });

    const navigate = useNavigate();
    const location = useLocation();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [currentTask, setCurrentTask] = useState(null);
    const [mode, setMode] = useState('view');
    const [status, setStatus] = useState("1");
    const [lastInsertedHkTaskId, setLastInsertedHkTaskId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [userId] = useState(sessionStorage.getItem('UserId'));
    const [dataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const hkTaskNameRef = useRef(null);
    const abrvRef = useRef(null);
    const remarkRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.HkTaskId) {
            setCurrentTask(location.state.HkTaskId);
            fetchTaskData(location.state.HkTaskId, "R");
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchTaskData = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstHkTask/RetriveMstHkTask`, {
                HkTaskId: parseInt(id),
                Flag: flag,
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const taskData = response.data.Data[0];
                setFormData({
                    HkTaskName: taskData.HkTaskName || '',
                    Abrv: taskData.Abrv || '',
                    Remark: taskData.Remark || '',
                });
                setStatus(taskData.status?.toString() || "1");
                setIsFormDisabled(true);
                setCurrentTask(taskData.HkTaskId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.info(response.data.Message || 'No record Found.');
            }
        } catch (error) {
            toast.error('Error while fetching work station.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            const params = {
                start: 0,
                PageSize: 7,
                SearchText: "",
            };
            try {
                const res = await axiosInstance.post('MstHkTask/getMstHkTaskDashBoard', { params });
                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (err) {
                toast.error('Error fetching data:', err);
            }
        };
        getRow();
    }, []);

    const handlePrevious = async () => {
        if (currentTask && currentTask > 1) {
            await fetchTaskData(currentTask, "P");
        }
    };

    const handleNext = async () => {
        if (currentTask) {
            await fetchTaskData(currentTask, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === hkTaskNameRef.current) {
                abrvRef.current.focus();
            } else if (event.target === abrvRef.current) {
                remarkRef.current.focus();
            }
        }
    };

    const handleSubmit = async () => {
        let hasError = false;

        if (!formData.HkTaskName) {
            toast.error('Task is required');
            setError((prev) => ({ ...prev, HkTaskName: true }));
            hasError = true;
        } else {
            setError((prev) => ({ ...prev, HkTaskName: false }));
        }

        if (hasError) return;

        try {
            const payload = {
                HkTaskName: formData.HkTaskName,
                Abrv: formData.Abrv,
                Remark: formData.Remark,
                status: status,
            };

            let response;
            if (mode === 'edit') {
                payload.HkTaskId = currentTask;
                payload.UpdatedBy = parseInt(userId, 7);
                response = await axiosInstance.patch(`MstHkTask/UpdateMstHkTask`, payload);
            } else {
                payload.CreatedBy = parseInt(userId, 7);
                response = await axiosInstance.post(`MstHkTask/InsertMstHkTask`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedHkTaskId(response.data.Data);
                    await fetchTaskData(response.data.Data, "R");
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentTask(response.data.Data);
                } else {
                    setMode('view');
                    setIsFormDisabled(true);
                    await UnLock(currentTask, "MstHkTask", "HkTaskId");
                }
            } else {
                toast.info(response.data.Message || 'No record found.');
            }
        } catch (error) {
            toast.error('Error while saving Task.');
        }
    };

    const handleEdit = async () => {
        let flag = await checkAndLock(currentTask, "MstHkTask", "HkTaskId");
        switch (flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record Already Locked.", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock.", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong.", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            HkTaskName: '',
            Abrv: '',
            Remark: '',
        });
        setCurrentTask(null);
        setStatus("1");

        setTimeout(() => {
            hkTaskNameRef.current?.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchTaskData(1, "L");
            await UnLock(currentTask, "MstHkTask", "HkTaskId");
            setStatus("1");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const handleExit = () => {
        navigate('/hktasktable');
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        const flag = await checkAndLock(currentTask, "MstHkTask", "HkTaskId");
        switch (flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchTaskData(currentTask, "D");
                await fetchTaskData(1, "N");
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
                toast.warn("Data Exists in MstYojanadtl.");
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong", { autoClose: 500 });
        }
    };

    return (
        <>
            <Box className="form-container" sx={{
                width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                maxWidth: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                height: { xs: "91.5vh", sm: "93.5vh", md: "auto", lg: "92vh" },
                overflowX: "hidden",
                overflowY: { xs: "auto", sm: "hidden", md: "hidden", lg: "hidden" },
            }}>
                <ToastContainer />
                <Grid container spacing={1} className="form_grid">
                    <Grid
                        item
                        xs={12}
                        className="form_title"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '7px', sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '7px' }, display: 'block' }}
                                disabled={mode !== 'view' || !currentTask || currentTask === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: 'block' }}
                                disabled={mode !== 'view' || !currentTask}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' },
                            }}
                        >
                            Task(ToDo) Master
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName="Task Master"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={8} lg={6}>
                                <TextField
                                    id="HkTaskName"
                                    name="HkTaskName"
                                    label={
                                        <span>
                                            HK Task <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.HkTaskName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.HkTaskName}
                                    helperText={error.HkTaskName && ""}
                                    inputRef={hkTaskNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={8} lg={6}>
                                <TextField
                                    id="Abrv"
                                    name="Abrv"
                                    label="Abbrivation/Code"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Abrv}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={abrvRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} >
                            <Grid item xs={12} md={5} lg={11}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Remark"
                                    variant="filled"
                                    fullWidth
                                    rows={2}
                                    multiline
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} lg={1}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }}
                                    onClick={handleAdd}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }}
                                    onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(dataForPrint).length > 0 && (
                    <ReportTable
                        columns={columns}
                        rows={rows}
                        title="Task Master"
                        contentRef={contentRef}
                        customStyles={{ backgroundColor: '#f5f5f5' }}
                    />
                )}
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default HKTaskMaster;
